export const getFilenameFromPath = (path: string) =>
  path.substring(path.lastIndexOf("/") + 1);
